module.exports = __webpack_public_path__ + "static/JiraMarketplace-313c073566419c582022d96267cf3f65.png";